export const GOOGLE_USER = "GOOGLE_USER";
export const BUSINESS = "BUSINESS";
export const RECRUITING_TYPE = "RECRUITING_TYPE";
